<template>
  <div class="sitemap">
    <h1 class="caption">Links</h1>
    <div class="line"></div>
    <ul>
      <li v-for="(item, i) in items" :key="i">
        <a class="link" :href="item.link" target="blank" :aria-label="item.text + ' (opens in a new tab)'">
          {{ item.text }}<Icon name="long-arrow-right"></Icon>
        </a>
        <div class="line"></div>
      </li>
      <li>
        <a href="https://contact.pepsico.com/bubly/" target="blank" class="link" aria-label="Contact (opens in a new tab)"
          >Contact<Icon name="long-arrow-right"></Icon
        ></a>
      </li>
    </ul>
    <div class="line"></div>
  </div>
</template>

<script>
import Icon from "vue-awesome/components/Icon";

export default {
  name: "sitemap",
  data() {
    return {
      items: [
        {
          text: "About Us",
          link: "https://contact.pepsico.com/bubly/about-us"
        },
        {
          text: "Privacy Policy",
          link: "https://contact.pepsico.com/bubly/privacy-policy"
        },
        {
          text: "Terms of Use",
          link: "https://contact.pepsico.com/bubly/terms-conditions"
        },
        {
          text: "About Our Ads",
          link: "https://contact.pepsico.com/bubly/about-our-ads"
        },
        {
          text: "Accessibility Statement",
          link: "https://contact.pepsico.com/bubly/accessibility-statement"
        }
      ]
    };
  },
  components: {
    Icon
  }
};
</script>

<style lang="scss" scoped>
@import "./../../variables.scss";

.social {
  color: $bubly-white;
  font-size: 18px;
}

ul{
  padding: 0;
  list-style-type: none;
}

.caption,
.link {
  width: 100%;
  display: block;
  text-align: left;
  padding: 12px;
  font-size: rem(15);
  box-sizing: border-box;
  margin: 0;
  font-weight: 300;

  @include breakpoint("tablet") {
    font-size: rem(21);
  }
}

.line {
  width: 100%;
  height: 1px;
  background: linear-gradient(
    to right,
    rgba(0, 191, 243, 0) 0%,
    rgba(0, 191, 243, 1) 20%,
    rgba(0, 191, 243, 1) 80%,
    rgba(0, 191, 243, 0) 100%
  );
}

.link {
  text-transform: normal;
  position: relative;
  box-sizing: border-box;

  @include breakpoint("tablet") {
    font-size: rem(18);
  }

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
}

.fa-icon {
  position: absolute;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/footer/Sitemap.vue